import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import noop from 'lodash/noop'
import React, { useCallback, useState } from 'react'

import StyledPickersTextField from 'components/form-fields/v5/StyledPickersTextField'

import type { PickerValue } from '@mui/x-date-pickers/internals'

type HHDesktopDatePickerProps = {
  label?: string
  value?: PickerValue
  disabled?: boolean
  TextFieldProps?: Record<string, unknown>
  PopperProps?: Record<string, unknown>
  restSlots?: Record<string, unknown>
  restSlotProps?: Record<string, unknown>
  onChange?: (value: Date | null, context?: unknown) => void
  disableScrollLock?: boolean
  shouldDisableDate?: (date: Date) => boolean
}

const HHDesktopDatePicker: React.FC<HHDesktopDatePickerProps> = ({
  label = '',
  value,
  disabled = false,
  TextFieldProps = {},
  PopperProps = {},
  onChange = noop,
  restSlots = {},
  restSlotProps = {},
  ...rest
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)

  const handleOpen = useCallback(() => {
    if (disabled) return
    setIsCalendarOpen(true)
  }, [disabled])

  const handleClose = useCallback(() => {
    if (disabled) return
    setIsCalendarOpen(false)
  }, [disabled])

  return (
    <DesktopDatePicker
      disabled={disabled}
      label={label}
      open={isCalendarOpen}
      slotProps={{
        textField: { onClick: handleOpen, fullWidth: true, ...TextFieldProps },
        popper: { ...PopperProps },
        ...restSlotProps,
      }}
      slots={{ textField: StyledPickersTextField, ...restSlots }}
      value={value}
      onChange={onChange}
      onClose={handleClose}
      onOpen={handleOpen}
      {...rest}
    />
  )
}

export default HHDesktopDatePicker
